import styled, { css } from "styled-components";
import { theme } from "../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { PopoverButton } from "../../../../../common-deprecated/styles/lexus/Tooltip";
import { legalStyle } from "../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const Wrapper = styled.div`
    height: auto;
    padding: 0 0 ${theme.space[2]}px;
    text-align: start;
`;

export const Title = styled.div`
    font-family: ${theme.fonts.book};
    font-size: 1.3rem;
    line-height: 2rem;
    text-align: start;
    color: ${theme.colors.platinumDark};

    ${PopoverButton} {
        margin-left: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        ${PopoverButton} {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;

export const Value = styled.span<{ isLoading?: boolean; discountedPrice?: boolean }>`
    display: inline-block;
    position: relative;
    padding-right: ${theme.space[1]}px;
    font-family: ${theme.fonts.book};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-decoration: ${({ discountedPrice }) => (discountedPrice ? "line-through" : "none")};
    color: ${({ discountedPrice }) => (discountedPrice ? theme.colors.platinumDark : theme.colors.black)};

    ${({ isLoading }) =>
        isLoading &&
        css`
            &:after {
                position: absolute;
                left: -5px;
                right: 0;
                width: 200px;
                max-width: 100%;
                color: ${theme.colors.silver};
                content: "0";
                background: ${theme.colors.silver};
                transition: width 0.3s ease;
                filter: blur(2px);
            }
        `};

    html[dir="rtl"] & {
        padding-left: ${theme.space[1]}px;
        padding-right: 0;

        ${({ isLoading }) =>
            isLoading &&
            css`
                &:after {
                    left: 0;
                    right: -5px;
                }
            `};
    }
`;

export const ValueWrapper = styled.div`
    display: inline-flex;
`;

export const KeyValue = styled.div<{ hasSmallFontSize?: boolean }>`
    text-align: start;
    ${Value} {
        font-size: ${({ hasSmallFontSize }) => (hasSmallFontSize ? "1.3rem" : "1.6rem")};
        line-height: ${({ hasSmallFontSize }) => (hasSmallFontSize ? "2rem" : "2.4rem")};
    }
`;

export const Suffix = styled.span`
    font-size: 1.6rem;
    color: ${theme.colors.black};
`;

export const Disclaimer = styled.button`
    padding: 0;
    background: transparent;
    border: none;

    svg,
    .icon {
        margin-left: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        svg,
        .icon {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;

export const LegalText = styled.div`
    margin: ${theme.space[1]}px 0 0;
    text-align: start;
    text-indent: 0;
    color: ${theme.colors.midnight};
    ${legalStyle};
`;
